import { FC } from 'react'

import { Task, TaskDeletionScope } from '@droidmap/project-service-contract'

import ConfirmationDialog from '../ConfirmationDialog'

interface TaskDeletionConfirmationDialogProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: (deletionScope: TaskDeletionScope) => void
  task: Task | null
  isLoading?: boolean
}

const TaskDeletionConfirmationDialog: FC<
  TaskDeletionConfirmationDialogProps
> = ({ isOpen, onClose, onConfirm, task, isLoading = false }) => {
  const handleConfirm = (result: TaskDeletionScope) => {
    onConfirm(result)
  }

  return (
    <ConfirmationDialog
      title="Delete Task"
      description={
        <>
          You&rsquo;re about to permanently delete{' '}
          <strong className="font-semibold text-text">
            {task?.name || 'this task'}
          </strong>
          . Choose below whether to retain its asset sets. This can&rsquo;t be
          undone.
        </>
      }
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={handleConfirm}
      confirmText="Delete"
      confirmOptions={{
        code: task?.name || '',
        flags: [
          {
            id: 'retain_input',
            label: 'Retain input asset sets',
          },
          {
            id: 'retain_output',
            label: 'Retain output asset sets',
          },
        ],
        transformFlags: (flags: Record<string, boolean>) => {
          if (flags['retain_input'] && flags['retain_output']) {
            return TaskDeletionScope.RETAIN_ALL_ASSETS
          } else if (flags['retain_input']) {
            return TaskDeletionScope.RETAIN_INPUT_ASSETS
          } else if (flags['retain_output']) {
            return TaskDeletionScope.RETAIN_OUTPUT_ASSETS
          } else {
            return TaskDeletionScope.DELETE_ALL
          }
        },
      }}
      cancelText="Cancel"
      variant="destructive"
      isLoading={isLoading}
    />
  )
}

export default TaskDeletionConfirmationDialog
